// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasStatus_CreateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/despesas_status/create
 *
 * Returns the newly-created expense status id.
 * Wire shape: { despesa_status_id: <int> }
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface DespesasStatus_CreateResponseDados {
despesa_status_id?: number
}

export type DespesasStatus_CreateResponse = ApiResponse<DespesasStatus_CreateResponseDados>;

registerResponseContract('DespesasStatus_CreateResponse', {
  despesa_status_id: { type: 'number',  required: false },
})
